module.exports = __webpack_public_path__ + "static/media/stolzl-medium.3a5f5d47.woff";